/**
 * File Name          : response-packet.model.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.0.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_BACKGROUNDTECH_LICENSE.txt', which is part of this source code package.
 */

import { PACKET_TYPE, Packet_Abstract, Packet } from "./packet.model";
import { PACKET_SUB_TYPE } from "./command-packet.model";
import { Output } from "../publishers/output.model";
import { DATA_TYPE } from "../data-type.model";
import { Publisher } from "../publishers/publisher.model";
import { ParameterAttribute } from "../parameters/parameter-attribute.model";
import { ParameterSet } from "../parameters/parameter-set.model";
import { Parameter } from "../parameters/parameter.model";
import { Filesystem_Drive } from "../file_system/drive.model";
import { Drive_Item } from "../file_system/drive-item.model";
import { HashDetails } from "../file_system/hash-details.model";
import { RESULT_CODE } from "./response-result.model";
import { MCU_IMAGE_STATE } from "../util/MCU.model";



export class ResponsePacket extends Packet {
    mPktSubType: PACKET_SUB_TYPE | null = null;
    
    // publisherId: number | null = null;
    outputList: Output[] = [];

    publishers: Publisher[] = [];

    pubId: number | null = null;
    pubName: string | null = null;

    outputIdx: number | null = null;

    outputName: string | null = null;
    outputUnits: string | null = null;

    driveIdx: number | null = null;
    freeSpace: number | null = null;
    totalSpace: number | null = null;

    portId: number | null = null;
    bytesPerSecTx: number | null = null;
    bytesPerSecRx: number | null = null;
    droppedPackets: number | null = null;
    txSuccess: number | null = null;
    txError: number | null = null;
    rxSuccess: number | null = null;
    rxError: number | null = null;

    fileRecorderState: FILERECORDER_STATE | null = null;
    fileSize: number | null = null;
    recordName: string | null = null;

    result: RESPONSE_RESULT | null = null;

    weekday: number | null = null;
    year: number | null = null;
    month: number | null = null;
    day: number | null = null;
    hour: number | null = null;
    minute: number | null = null;
    second: number | null = null;
    fracSeconds: number | null = null;
    success: number | null = null;
    deviceSN: string | null = null;
    projectID: number | null = null;
    deviceType: number | null = null;
    roleID: number | null = null;
    appSpecInfo: number | null = null;
    fwReleaseType: string | null = null;
    fwMajorVersion: number | null = null;
    fwMinorVersion: number | null = null;
    fwBugVersion: number | null = null;
    hwProductID: number | null = null;
    hwSubcomponentID: number | null = null;
    hwMajorVersion: number | null = null;
    hwMinorVersion: number | null = null;
    dfuType: number | null = null;
    dfuMajorVersion: number | null = null;
    dfuMinorVersion: number | null = null;
    dfuBugVersion: number | null = null;
    bootType: number | null = null;
    bootMajorVersion: number | null = null;
    bootMinorVersion: number | null = null;
    bootBugVersion: number | null = null;
    compileTime: string | null = null;

    formatHash: number | null = null;
    valueHash: number | null = null;
    paramCount: number | null = null;

    parameterSets: ParameterSet[] | null = null;
    parameters: Parameter[] = [];
    paramSetUUID: number | null = null
    accessZone: number | null = null;
    paramSetName: string | null = null;
    paramUUID: number | null = null;
    paramVal: Uint8Array | null = null;
    paramType: number | null = null;
    paramNumBytes: number | null = null;
    paramNumElements: number | null = null;
    paramName: string | null = null;
    attributeBytes: number | null = null;
    attributeCount: number | null = null;
    attributes: ParameterAttribute[] | null = null;

    fileSystemDrives: Filesystem_Drive[] | null = null;
    driveItem: Drive_Item | null = null;
    fileIdx: number | null = null;
    controlFlags: number | null = null;
    chunkHash: number | null = null;
    hash_details: HashDetails | null = null;
    startAddress: number | null = null;
    data_size: number | null = null;
    file_position: number | null = null;
    fileData: Uint8Array | null = null;

    batteryState: number | null = null;
    cmd_type: PACKET_SUB_TYPE | null = null;
    result_code: RESULT_CODE | null = null;

    image_count: number | null = null;
    imageInfo: MCU_IMAGE_STATE | null = null;

    systemStatusList: {state: number, detail: number, info: number}[] | null = null;



    static fromPacket(pkt: Packet, outputInfo: Publisher[]): [boolean, ResponsePacket] {
        var thisPkt = new ResponsePacket()

        thisPkt.mBytes = pkt.mBytes
        thisPkt.mPayloadLength = pkt.mPayloadLength
        thisPkt.mPacketNumber = pkt.mPacketNumber
        thisPkt.mPacketType = pkt.mPacketType

        thisPkt.rxCRC = pkt.rxCRC
        thisPkt.calcCRC = pkt.calcCRC
        thisPkt.validCRC = pkt.validCRC

        thisPkt.parseTypeHeader()

        var success = false;
        
        try {
            success = thisPkt.parseBody(outputInfo)
        } catch (error) {
            console.warn("Error parsing outputset packet: ", error)
            success = false
        }

        return [success, thisPkt]
    }

    parseTypeHeader() {
        this.mPktSubType = PACKET_SUB_TYPE.from(this.mBytes![5])
    }

    // parseBody(): boolean {


    //     return false;
    // }


    parseBody(outputInfo: Publisher[]): boolean {
        try {
            switch (this.mPktSubType) {
                case PACKET_SUB_TYPE.GET_OUTPUTS: {
                    this.pubId = new DataView(this.mBytes!.buffer, 8, 2).getUint16(0, true);
        
                    let pub: Publisher | undefined = undefined;
                    for (let spub of outputInfo) {
                        if (spub.pubId === this.pubId) {
                            pub = spub;
                        }
                    }
        
                    let byteIdx = 10;
                    let nOuts = 0;
                    while (nOuts < pub!.numOutputs) {
                        let output = new Output(
                            this.mBytes![byteIdx],
                            this.mBytes![byteIdx + 1],
                            this.mBytes![byteIdx + 2]
                        );
        
                        this.outputList.push(output);
        
                        byteIdx += 3;
                        nOuts++;
                    }
                    break;
                }
                case PACKET_SUB_TYPE.GET_PUBLISHERS: {
                    let byteIdx = 8;
                    while (byteIdx + 8 < this.mBytes!.length) {
                        let dataView = new DataView(this.mBytes!.buffer, byteIdx, 9);
                        let pubId = dataView.getUint16(0, true);
                        let pubIdx = this.mBytes![byteIdx + 2];
                        let numOutputs = this.mBytes![byteIdx + 3];
                        let accessTypes = this.mBytes![byteIdx + 4];
                        let expectedPeriod = dataView.getUint32(5, true);
        
                        this.publishers.push(
                            new Publisher(
                                pubId,
                                pubIdx,
                                numOutputs,
                                accessTypes,
                                expectedPeriod
                            )
                        );
                        byteIdx += 9;
                    }
                    break;
                }
                case PACKET_SUB_TYPE.GET_PUBLISHER_NAME: {
                    this.pubId = new DataView(this.mBytes!.buffer, 8, 2).getUint16(0, true);
        
                    let stringLast = this.mBytes!.indexOf(0x00, 10);
                    this.pubName = String.fromCharCode.apply(null, Array.from(this.mBytes!.slice(10, stringLast >= 0 ? stringLast : this.mBytes!.length)));
                    break;
                }
                case PACKET_SUB_TYPE.GET_OUTPUT_NAME: {
                    this.pubId = new DataView(this.mBytes!.buffer, 8, 2).getUint16(0, true);
                    this.outputIdx = this.mBytes![10];
        
                    let stringLast = this.mBytes!.indexOf(0x00, 11);
                    this.outputName = String.fromCharCode.apply(null, Array.from(this.mBytes!.slice(11, stringLast >= 0 ? stringLast : this.mBytes!.length)));
                    break;
                }
                case PACKET_SUB_TYPE.GET_OUTPUT_UNITS: {
                    this.pubId = new DataView(this.mBytes!.buffer, 8, 2).getUint16(0, true);
                    this.outputIdx = this.mBytes![10];

                    let stringLast = this.mBytes!.indexOf(0x00, 11);
                    this.outputUnits = String.fromCharCode.apply(null, Array.from(this.mBytes!.slice(11, stringLast >= 0 ? stringLast : this.mBytes!.length)));
                    break;
                }
                // case PACKET_SUB_TYPE.GET_DISK_STATS: {
                //     this.driveIdx = this.mBytes![8];
                //     this.freeSpace = new DataView(this.mBytes!.buffer, 9, 4).getUint32(0, true);
                //     this.totalSpace = new DataView(this.mBytes!.buffer, 13, 4).getUint32(0, true);
                //     break;
                // }
                case PACKET_SUB_TYPE.GET_PORT_STATS: {
                    this.portId = new DataView(this.mBytes!.buffer, 8, 2).getUint16(0, true);
                    this.bytesPerSecTx = new DataView(this.mBytes!.buffer, 10, 4).getUint32(0, true);
                    this.bytesPerSecRx = new DataView(this.mBytes!.buffer, 14, 4).getUint32(0, true);
                    this.txSuccess = new DataView(this.mBytes!.buffer, 18, 4).getUint32(0, true);
                    this.txError = new DataView(this.mBytes!.buffer, 22, 4).getUint32(0, true);
                    this.rxSuccess = new DataView(this.mBytes!.buffer, 26, 4).getUint32(0, true);
                    this.rxError = new DataView(this.mBytes!.buffer, 30, 4).getUint32(0, true);
                    break;
                }
                case PACKET_SUB_TYPE.GET_FILERECORDER_STATS: {
                    console.log("Parsing GET_FILERECORDER_STATS response packet");
                    this.portId = new DataView(this.mBytes!.buffer, 8, 2).getUint16(0, true);
                    this.fileRecorderState = FILERECORDER_STATE.from(this.mBytes![10]);
                    this.fileSize = new DataView(this.mBytes!.buffer, 11, 4).getUint32(0, true);
                    
                    let stringLast = this.mBytes!.indexOf(0x00, 15);
                    this.recordName = String.fromCharCode.apply(null, Array.from(this.mBytes!.slice(15, stringLast >= 0 ? stringLast : this.mBytes!.length)));
                    break;
                }
                case PACKET_SUB_TYPE.ENABLE_FILERECORDER: {
                    this.result = RESPONSE_RESULT.from(this.mBytes![8]);
                    break;
                }
                case PACKET_SUB_TYPE.ENABLE_FILERECORDER_V2: {
                    this.result = RESPONSE_RESULT.from(this.mBytes![8]);
                    break;
                }
                case PACKET_SUB_TYPE.GET_TIME: {
                    this.fracSeconds = this.mBytes![8];
                    this.second = this.mBytes![9];
                    this.minute = this.mBytes![10];
                    this.hour = this.mBytes![11];
                    break;
                }
                case PACKET_SUB_TYPE.GET_DATE: {
                    this.day = this.mBytes![8];
                    this.month = this.mBytes![9];
                    this.year = this.mBytes![10];
                    this.weekday = this.mBytes![11];
                    break;
                }
                case PACKET_SUB_TYPE.SET_TIME: {
                    this.success = this.mBytes![8];
                    break;
                }
                case PACKET_SUB_TYPE.SET_DATE: {
                    this.success = this.mBytes![8];
                    break;
                }
                case PACKET_SUB_TYPE.GET_DEVINFO: {
                    //SN (8 bytes)
                    this.deviceSN = Array.from(this.mBytes!.slice(8, 16)).map(b => b.toString(16).padStart(2, '0').toUpperCase()).join(' ');
                    //UNIT_ID (4 bytes): uint8 ProjectID, uint8 DevType, uint8 RoleID, uint8 AppSpec
                    this.projectID = this.mBytes![16]
                    this.deviceType = this.mBytes![17]
                    this.roleID = this.mBytes![18]
                    this.appSpecInfo = this.mBytes![19]
                    //FW VERSION (4 bytes): uint16 MajorVersion, uint8 MinorVersion, uint8 BugVersion
                    let fwmv = new DataView(this.mBytes!.buffer, 20, 2).getUint16(0, true);
                    this.fwReleaseType = ((fwmv & 0x8000) >> 15) ? "Debug" : "Release";
                    this.fwMajorVersion = fwmv & 0x7FFF
                    this.fwMinorVersion = this.mBytes![22]
                    this.fwBugVersion = this.mBytes![23]
                    //HW VERSION (8 bytes): uint16 ProductID, uint8 MajorVersion, uint8 MinorVersion
                    this.hwProductID = new DataView(this.mBytes!.buffer, 24, 4).getUint32(0, true);
                    this.hwSubcomponentID = new DataView(this.mBytes!.buffer, 28, 2).getUint16(0, true);
                    this.hwMajorVersion = this.mBytes![30]
                    this.hwMinorVersion = this.mBytes![31]
                    //DFU VERSON (4 bytes): uint8 DFUType, uint8 MajorVersion, uint8 MinorVersion, uint8 BugVersion
                    this.dfuType = this.mBytes![32]
                    this.dfuMajorVersion = this.mBytes![33]
                    this.dfuMinorVersion = this.mBytes![34]
                    this.dfuBugVersion = this.mBytes![35]
                    //BOOTLOADER VERSION (4bytes): uint8 BootType, uint8 MajorVersion, uint8 MinorVersion, uint8 BugVersion
                    this.bootType = this.mBytes![36]
                    this.bootMajorVersion = this.mBytes![37]
                    this.bootMinorVersion = this.mBytes![38]
                    this.bootBugVersion = this.mBytes![39]

                    //COMPILE TIME (remaining bytes -> string?)
                    this.compileTime = String.fromCharCode.apply(null, Array.from(this.mBytes!.slice(40)));
                    break;
                }
                case PACKET_SUB_TYPE.GET_PARAMETER_SETS: {
                    

                    let parameterSets: ParameterSet[] = []
                    let dv = new DataView(this.mBytes!.buffer, 8)

                    let setCount = dv.getUint16(0, true)

                    for(let i=0; i < setCount; i++) {
                        let setUUID = dv.getUint16((i+1)*2, true)

                        let setTypeId = (0xFFF0 & setUUID)>>4
                        let setInstance = (0x000F & setUUID)

                        let setIndex = parameterSets.findIndex((value)=>value.setTypeId == setTypeId)
                        if(setIndex < 0) {
                            parameterSets.push({
                                setTypeId: setTypeId,
                                instances: [setInstance],
                                parameters: []
                            })
                        } else {
                            parameterSets[setIndex].instances.push(setInstance)
                        }

                    }
                    this.parameterSets = parameterSets

                    break;
                }
                case PACKET_SUB_TYPE.GET_PARAMETER_SET_INFO: {
                    let dv = new DataView(this.mBytes!.buffer, 8)
                    this.paramSetUUID = dv.getUint16(0, true)
                    let paramCount = dv.getUint16(2, true)
                    let formatHash = dv.getUint16(4, true)
                    let valueHash = dv.getUint16(6, true)
                    this.accessZone = dv.getUint8(8);
                    this.paramSetName = String.fromCharCode.apply(null, Array.from(this.mBytes!.slice(17, this.mBytes!.indexOf(0x00, 17) >= 0 ? this.mBytes!.indexOf(0x00, 17) : this.mBytes!.length)));



                    break;
                }
                case PACKET_SUB_TYPE.GET_PARAMETERS: {
                    let dv = new DataView(this.mBytes!.buffer, 8)
                    let paramSetUUID = dv.getUint16(0, true)
                    let paramCount = dv.getUint16(2, true)

                    let parameters: Parameter[] = []
                    

                    for(let i=0; i<paramCount; i++) {
                        let paramUUID =  dv.getUint16(4 + i*2, true)

                        parameters.push(new Parameter(paramUUID&0xFFFF))
                    }
                    this.parameters = parameters
                    this.paramSetUUID = paramSetUUID

                    break;
                }
                // case PACKET_SUB_TYPE.GET_PARAMETER_LIST: {
                //     this.formatHash = new DataView(this.mBytes!.buffer, 8, 2).getUint16(0, true);
                //     this.valueHash = new DataView(this.mBytes!.buffer, 10, 2).getUint16(0, true);
                //     this.paramCount = new DataView(this.mBytes!.buffer, 12, 2).getUint16(0, true);

                //     this.parameters = []
                    
                //     for(let i=0; i<this.paramCount; i++) {
                //         let uuid = new DataView(this.mBytes!.buffer, 14 + i*2, 2).getUint16(0, true);
                //         this.parameters.push(new Parameter(uuid))
                //     }
                //     break;
                // }
                case PACKET_SUB_TYPE.GET_PARAMETER_INFO: {
                    let dv = new DataView(this.mBytes!.buffer, 8)
                    this.paramUUID = dv.getUint32(0, true);
                    this.paramType = dv.getUint16(4, true);
                    this.paramNumBytes = dv.getUint16(6, true);
                    this.paramNumElements = dv.getUint16(8, true);
                    let nameEndIdx = this.mBytes!.indexOf(0x00, 23)
                    this.paramName = String.fromCharCode.apply(null, Array.from(this.mBytes!.slice(23, nameEndIdx)));

                    // let attrIdx = nameEndIdx + 1 - 8
                    // this.attributeBytes = dv.getUint16(attrIdx, true);
                    // this.attributeCount = dv.getUint16(attrIdx + 2, true)

                    // this.attributes = []

                    // attrIdx += 4
                    // while(attrIdx < dv.byteLength) {
                    //     let attrUUID = dv.getUint16(attrIdx, true); attrIdx += 2;
                    //     let attrBodySize = dv.getUint16(attrIdx, true); attrIdx +=2;
                    //     let attrBytes = new Uint8Array(dv.buffer).slice(attrIdx, attrIdx + attrBodySize); attrIdx += attrBodySize
                    //     this.attributes.push(new ParameterAttribute(attrUUID, attrBytes))
                    // }

                    

                    break;
                }
                case PACKET_SUB_TYPE.GET_PARAMETER_VAL: {
                    let dv = new DataView(this.mBytes!.buffer, 8)
                    this.paramUUID = dv.getUint32(0, true);
                    this.paramVal = this.mBytes!.slice(12)
                    break;
                }
                case PACKET_SUB_TYPE.GET_DRIVE_LIST: {
                    let driveCount = this.mBytes![8];
                    this.fileSystemDrives = [];
                    let dataIndex = 9;
                    for(let i=0; i< driveCount; i++) {
                        let arch = this.mBytes![dataIndex];
                        let mounted = this.mBytes![dataIndex + 1] > 0;
                        let pathEndIndex = this.mBytes!.indexOf(0x00, dataIndex + 2);
                        let path = String.fromCharCode.apply(null, Array.from(this.mBytes!.slice(dataIndex + 2, pathEndIndex >= 0 ? pathEndIndex : this.mBytes!.length)));
                        this.fileSystemDrives.push({
                            index: i,
                            arch,
                            mounted,
                            path,
                            items: []
                        });
                        dataIndex = pathEndIndex + 1;
                    }
                    break;
                }
                case PACKET_SUB_TYPE.DIR_READ_NEXT: {
                    this.driveIdx = this.mBytes![8];
                    // const itemIndex = this.mBytes![9];
                    const itemType = this.mBytes![9];
                    const itemSize = new DataView(this.mBytes!.buffer, 10, 4).getUint32(0, true);
                    const itemName = String.fromCharCode.apply(null, Array.from(this.mBytes!.slice(14, this.mBytes!.indexOf(0x00, 14) >= 0 ? this.mBytes!.indexOf(0x00, 14) : this.mBytes!.length))); 

                    this.driveItem = {
                        // index: itemIndex,
                        type: itemType,
                        size: itemSize,
                        name: itemName
                    }
                    break;
                }
                case PACKET_SUB_TYPE.DIR_OPEN: {
                    break;
                }
                case PACKET_SUB_TYPE.FILE_OPEN: {
                    this.driveIdx = this.mBytes![8];
                    this.fileIdx = new DataView(this.mBytes!.buffer, 9, 2).getUint16(0, true);
                    break;
                }
                case PACKET_SUB_TYPE.GET_FILE_HASH: {
                    const dv = new DataView(this.mBytes!.buffer, 8);
                    this.driveIdx = this.mBytes![8];
                    this.fileIdx = dv.getUint16(1, true);
                    this.hash_details = {
                        start_address: dv.getUint32(3, true),
                        num_bytes_to_hash: dv.getUint32(7, true),
                        digest: dv.getUint32(11, true)
                    };
                    break;
                }
                case PACKET_SUB_TYPE.GET_FILE_DATA: {
                    const dv = new DataView(this.mBytes!.buffer, 8);
                    this.driveIdx = this.mBytes![8];
                    this.fileIdx = dv.getUint16(1, true);
                    this.startAddress = dv.getUint32(3, true);
                    this.data_size = dv.getUint32(7, true);
                    this.fileData = this.mBytes!.slice(19, 19+this.data_size);
                    break;
                }
                case PACKET_SUB_TYPE.FILE_WRITE: {
                    const dv = new DataView(this.mBytes!.buffer, 8);
                    this.driveIdx = dv.getUint8(0);
                    this.fileIdx = dv.getUint16(1, true);
                    this.controlFlags = dv.getUint8(3);
                    this.startAddress = dv.getUint32(4, true);
                    this.data_size = dv.getUint32(8, true);
                    this.chunkHash = dv.getUint32(12, true);
                    this.file_position = dv.getUint32(16, true);
                    this.result_code = dv.getUint8(20);
                    break;
                }
                case PACKET_SUB_TYPE.GET_BATCHRGSTATE: {
                    this.batteryState = this.mBytes![8];
                    break;
                }
                case PACKET_SUB_TYPE.BAD_PACKET: {
                    this.cmd_type = this.mBytes![8];
                    this.result_code = this.mBytes![9];
                    break;
                }
                case PACKET_SUB_TYPE.DFU_GET_IMAGE_LIST: {
                    this.image_count = this.mBytes![8];
                    break;
                }
                case PACKET_SUB_TYPE.FILE_CLOSE: {
                    this.result_code = this.mBytes![8];
                    break;
                }
                case PACKET_SUB_TYPE.DFU_GET_IMAGE_INFO: {
                    this.imageInfo = MCU_IMAGE_STATE.fromBytes(this.mBytes!.slice(8, 8 + MCU_IMAGE_STATE.BYTE_LENGTH));
                    break;
                }
                case PACKET_SUB_TYPE.DFU_UPLOAD_IMAGE: {
                    const dv = new DataView(this.mBytes!.buffer, 8);
                    this.file_position = dv.getUint32(0, true);
                    this.result_code = dv.getUint8(4);
                    break;
                }
                case PACKET_SUB_TYPE.GET_SYSTEM_STATUS: {
                    const dv = new DataView(this.mBytes!.buffer, 8);
                    let offset = 0;
                    let count = dv.getUint8(offset); offset += 1;
                    let systemStatusList: {state: number, detail: number, info: number}[] = []
                    for(let i=0; i<count; i++) {
                        let state = dv.getUint8(offset); offset += 1;
                        let detail = dv.getUint8(offset); offset += 1;
                        let info = dv.getUint16(offset, true); offset += 2;

                        systemStatusList.push({state, detail, info})
                    }

                    this.systemStatusList = systemStatusList;


                    break;
                }
                case PACKET_SUB_TYPE.PORT_UNSUBSCRIBE_ALL:
                    break;
                case PACKET_SUB_TYPE.REFORMAT_DRIVE:
                case PACKET_SUB_TYPE.FILE_REMOVE:
                case PACKET_SUB_TYPE.SAVE_ALL_PARAMETERS:
                case PACKET_SUB_TYPE.DFU_GET_STATUS:
                case PACKET_SUB_TYPE.DFU_CONFIRM_IMAGE:
                case PACKET_SUB_TYPE.DFU_TEST_IMAGE:
                case PACKET_SUB_TYPE.DFU_ERASE_IMAGE:
                case PACKET_SUB_TYPE.DFU_LOAD_IMAGE:{
                    this.result_code = this.mBytes![8];
                    break;
                }
                default:
                    console.log("ATTENTION: ATTEMPTED TO PARSE AN UNKNOWN PACKET TYPE:" + this.mPktSubType)
                    return false;
            }
        } catch (error) {
            console.warn("Error parsing response packet body: ", error)
            return false;
        }
        return true;
    }

    override packetSubTypeAsString(): string {
        switch(this.mPktSubType) {
            case PACKET_SUB_TYPE.NA: return "NA"
            case PACKET_SUB_TYPE.TEST: return "Test"
            case PACKET_SUB_TYPE.SUBSCRIBE_BY_INDEX: return "Subscribe by Index"
            case PACKET_SUB_TYPE.SUBSCRIBE_BY_ID: return "Subscribe by ID"
            case PACKET_SUB_TYPE.GET_PORTS: return "Get Ports"
            case PACKET_SUB_TYPE.GET_PORTS_NAME: return "Get Ports Name"
            case PACKET_SUB_TYPE.GET_PUBLISHERS: return "Get Publishers"
            case PACKET_SUB_TYPE.GET_PUBLISHER_NAME: return "Get Publisher Name"
            case PACKET_SUB_TYPE.GET_OUTPUTS: return "Get Outputs"
            case PACKET_SUB_TYPE.GET_OUTPUT_NAME: return "Get Output Name"
            case PACKET_SUB_TYPE.GET_OUTPUT_UNITS: return "Get Output Units"
            case PACKET_SUB_TYPE.GET_SUBSCRIBERS: return "Get Subscribers"
            case PACKET_SUB_TYPE.GET_SUBSCRIBER_NAME: return "Get Subscriber Name"
            case PACKET_SUB_TYPE.GET_PORT_STATS: return "Get Port Stats"
            case PACKET_SUB_TYPE.SELF_TEST: return "Self Test"
            case PACKET_SUB_TYPE.PORT_UNSUBSCRIBE_ALL: return "Port Unsubscribe All"
        
            case PACKET_SUB_TYPE.GET_PARAMETER_VAL: return "Get Parameter Val"
            case PACKET_SUB_TYPE.SET_PARAMETER_VAL: return "Set Parameter Val"

            case PACKET_SUB_TYPE.GET_PARAMETER_INFO: return "Get Parameter Info"
        
            case PACKET_SUB_TYPE.GET_TIME: return "Get Time"
            case PACKET_SUB_TYPE.SET_TIME: return "Set Time"
            case PACKET_SUB_TYPE.GET_DATE: return "Get Date"
            case PACKET_SUB_TYPE.SET_DATE: return "Set Date"
            case PACKET_SUB_TYPE.GET_MICROSECONDS: return "Get Mircoseconds"
            case PACKET_SUB_TYPE.SET_MICROSECONDS: return "Set Microseconds"
            case PACKET_SUB_TYPE.GET_POWER: return "Get Power"
            case PACKET_SUB_TYPE.SET_POWER: return "Set Power"
            case PACKET_SUB_TYPE.GET_BATCHRGSTATE: return "Get Battery Charge State"
            case PACKET_SUB_TYPE.GET_DEVINFO: return "Get Device Info"
            case PACKET_SUB_TYPE.GET_DEVNAME: return "Get Device Name"
            case PACKET_SUB_TYPE.IDENTIFY: return "Identify"
            case PACKET_SUB_TYPE.TAG_DATA: return "Tag Data"
        
            case PACKET_SUB_TYPE.GET_FILERECORDER_STATS: return "Get Filerecorder Stats"
            case PACKET_SUB_TYPE.ENABLE_FILERECORDER: return "Enable Filerecorder"
            case PACKET_SUB_TYPE.ENABLE_AHRS: return "Enable AHRS"
            case PACKET_SUB_TYPE.ENABLE_FILERECORDER_V2: return "Enable Filerecorder V2"
            default: return "unknown"
        }
    }
    
    override packetPayloadAsString(): string {
        switch(this.mPktSubType) {
            case PACKET_SUB_TYPE.NA: return ""
            case PACKET_SUB_TYPE.TEST: return ""
            case PACKET_SUB_TYPE.SUBSCRIBE_BY_INDEX: return ""
            case PACKET_SUB_TYPE.SUBSCRIBE_BY_ID: return ""
            case PACKET_SUB_TYPE.GET_PORTS: return ""
            case PACKET_SUB_TYPE.GET_PORTS_NAME: return ""
            case PACKET_SUB_TYPE.GET_PUBLISHERS: {
                let pktStr = ``
                for(let pub of this.publishers) {
                    pktStr += `\nID: ${pub.pubId} \tIndex: ${pub.pubIdx} \tNum Outputs: ${pub.numOutputs} \tAccessTypes: ${pub.accessTypes} \tPeriod: ${pub.expectedPeriod}`
                }
                return pktStr
            }
            case PACKET_SUB_TYPE.GET_PUBLISHER_NAME: return `PubId: ${this.pubId} \nName: ${this.pubName}`
            case PACKET_SUB_TYPE.GET_OUTPUTS: {
                let pktStr = `PubId: ${  this.pubId}`
                for(let output of this.outputList) {
                    pktStr += `\nOutput Index: ${output.index} \tType: ${output.type} \tLength: ${output.length}`
                }
                return pktStr
            }
            case PACKET_SUB_TYPE.GET_OUTPUT_NAME: return `PubId: ${  this.pubId} \nOutputIdx: ${this.outputIdx} \n Output Name: ${this.outputName}`
            case PACKET_SUB_TYPE.GET_OUTPUT_UNITS: return `PubId: ${  this.pubId} \nOutputIdx: ${this.outputIdx} \n Output Units: ${this.outputUnits}`
            case PACKET_SUB_TYPE.GET_SUBSCRIBERS: return ""
            case PACKET_SUB_TYPE.GET_SUBSCRIBER_NAME: return ""
            case PACKET_SUB_TYPE.GET_PORT_STATS: return `Port: ${this.portId} \n Tx Bytes/s: ${this.bytesPerSecTx} \n Rx bytes/s: ${this.bytesPerSecRx} \nTx Success: ${this.txSuccess} \nTx Error: ${this.txError} \nRx Success: ${this.rxSuccess} \nRx Error: ${this.rxError}`
            case PACKET_SUB_TYPE.SELF_TEST: return ""
            case PACKET_SUB_TYPE.PORT_UNSUBSCRIBE_ALL: return `Port: ${this.portId}`
        
            case PACKET_SUB_TYPE.GET_PARAMETER_VAL: return ""
            case PACKET_SUB_TYPE.SET_PARAMETER_VAL: return ""
            case PACKET_SUB_TYPE.GET_PARAMETER_INFO: return ""
        
            case PACKET_SUB_TYPE.GET_TIME: return `Time: ${this.hour}:${this.minute}:${this.second}:${this.fracSeconds}/256`
            case PACKET_SUB_TYPE.SET_TIME: return `Success: ${this.result}`
            case PACKET_SUB_TYPE.GET_DATE: return `Date: ${this.year}/${this.month}/${this.day} (${this.weekday})`
            case PACKET_SUB_TYPE.SET_DATE: return `Success: ${this.result}`
            case PACKET_SUB_TYPE.GET_MICROSECONDS: return ""
            case PACKET_SUB_TYPE.SET_MICROSECONDS: return ""
            case PACKET_SUB_TYPE.GET_POWER: return ""
            case PACKET_SUB_TYPE.SET_POWER: return ""
            case PACKET_SUB_TYPE.GET_BATCHRGSTATE: return ""
            case PACKET_SUB_TYPE.GET_DEVINFO: return `Device SN: ${this.deviceSN} \n Project ID: ${this.projectID} \tDevice Type: ${this.deviceType} \tRole ID: ${this.roleID} \tApp Spec Info: ${this.appSpecInfo} \n FW Version: ${this.fwMajorVersion}.${this.fwMinorVersion}.${this.fwBugVersion} \nHW Product ID: ${this.hwProductID}\nHW Version: ${this.hwMajorVersion}.${this.hwMinorVersion} \nCompile Time: ${this.compileTime}`
            case PACKET_SUB_TYPE.GET_DEVNAME: return ""
            case PACKET_SUB_TYPE.IDENTIFY: return ""
            case PACKET_SUB_TYPE.TAG_DATA: return ""
        
            case PACKET_SUB_TYPE.GET_FILERECORDER_STATS: return `Port: ${this.portId} \nState: ${this.fileRecorderState} \nFile Size: ${this.fileSize} \nRecord Name: ${this.recordName}`
            case PACKET_SUB_TYPE.ENABLE_FILERECORDER: return `Success: ${this.result}`
            case PACKET_SUB_TYPE.ENABLE_FILERECORDER_V2: return `Success: ${this.result}`
            case PACKET_SUB_TYPE.ENABLE_AHRS: return ""
            default: return ""
        }
    }

}

export enum RESPONSE_RESULT {
    SUCCESS = 0x00,
    FAIL = 0x01,
    BUSY = 0x02,
    READY = 0x03,
    NA = 0x04,
}

export namespace RESPONSE_RESULT {
    export function from(b: number): RESPONSE_RESULT | null {
        for (const key in RESPONSE_RESULT) {
            if (RESPONSE_RESULT[key as keyof typeof RESPONSE_RESULT] === b) {
                return RESPONSE_RESULT[key as keyof typeof RESPONSE_RESULT] as RESPONSE_RESULT;
            }
        }
        return null;
    }
}

export enum FILERECORDER_STATE {
    NA = 0x00,
    DISABLED = 0x01,
    READY = 0x02,
    RCORDING = 0x03,
    FAULT = 0x04
}

export namespace FILERECORDER_STATE {
    export function from(b: number): FILERECORDER_STATE | null {
        for (const key in FILERECORDER_STATE) {
            if (FILERECORDER_STATE[key as keyof typeof FILERECORDER_STATE] === b) {
                return FILERECORDER_STATE[key as keyof typeof FILERECORDER_STATE] as FILERECORDER_STATE;
            }
        }
        return null;
    }
}

export enum STATUS_TYPE {
    NA = 0x00,
    ERROR = 0x01,
    TEST = 0x02,
    IDENTIFY = 0x2C,
    TAG_DATA = 0x2D,
    SUBSYS_STATUS_CHANGED = 0x30,
};